var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrazil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.69568L21.913 12L11.9999 19.3044L2.08691 12L11.9999 4.69568Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.1739C14.3052 16.1739 16.174 14.3052 16.174 12C16.174 9.69483 14.3052 7.82611 12.0001 7.82611C9.69489 7.82611 7.82617 9.69483 7.82617 12C7.82617 14.3052 9.69489 16.1739 12.0001 16.1739Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91276 11.7391C9.18695 11.7391 8.48649 11.8495 7.82715 12.0544C7.85635 14.3344 9.71279 16.1739 11.9997 16.1739C13.4139 16.1739 14.6628 15.47 15.4178 14.3942C14.1261 12.7771 12.1385 11.7391 9.91276 11.7391Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0962 12.7997C16.1464 12.5408 16.1735 12.2736 16.1735 12C16.1735 9.69478 14.3048 7.82611 11.9997 7.82611C10.2796 7.82611 8.80306 8.86678 8.16406 10.3526C8.72891 10.2356 9.31372 10.1739 9.91273 10.1739C12.337 10.1739 14.5301 11.1816 16.0962 12.7997Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/8259863e.svg";
export { SvgBrazil as ReactComponent };